import { FC, memo } from 'react'
import reactStringReplace from 'react-string-replace'

import * as SC from '../styles'
import { Accordion, Link, Panel, PanelFace, TextBadge } from 'ui/components'
import { Changes } from 'ui/temp'

import { RelationshipChangesProps } from './RelationshipChangesProps'

export const RelationshipChanges: FC<RelationshipChangesProps> = memo((props) => {
  const { data, showAll } = props

  return (
    <Panel
      title="Relationship"
      titleTagAs="h3"
      face={PanelFace.SMALL_PRIMARY}
      isArrowButton={true}
      rounded={true}
      shadowed={true}
      blockOnClickOnTitle={false}
      expanded={showAll}
    >
      {data.showChanges && (
        <Accordion
          title="Updated"
          expanded={showAll}
          actions={<TextBadge color="default">{data.showChanges.length} changes</TextBadge>}
        >
          <SC.AccordionTitle>
            {reactStringReplace(data.title, /%#(.*)#%/g, (match, i) => (
              <Link key={i} to={'/relationships/$id'} params={{ id: data.id.toString() }}>
                {match}
              </Link>
            ))}
            :
          </SC.AccordionTitle>
          <SC.LongText>
            {data.showChanges.map((el, key) => (
              <Changes data={el} key={key} />
            ))}
          </SC.LongText>
        </Accordion>
      )}
    </Panel>
  )
})
